import React from 'react';
import PropTypes from 'prop-types';

const TONES = {
  success: 'tw-bg-emerald-500/10 tw-text-emerald-700 tw-ring-emerald-500/25 dark:tw-text-emerald-300',
  neutral: 'tw-bg-slate-500/10 tw-text-slate-600 tw-ring-slate-500/20 dark:tw-text-slate-300',
  info: 'tw-bg-blue-500/10 tw-text-blue-700 tw-ring-blue-500/25 dark:tw-text-blue-300',
  warning: 'tw-bg-amber-500/10 tw-text-amber-700 tw-ring-amber-500/25 dark:tw-text-amber-300',
  danger: 'tw-bg-rose-500/10 tw-text-rose-700 tw-ring-rose-500/25 dark:tw-text-rose-300',
  accent: 'tw-bg-teal-500/10 tw-text-teal-700 tw-ring-teal-500/25 dark:tw-text-teal-300',
  violet: 'tw-bg-violet-500/10 tw-text-violet-700 tw-ring-violet-500/25 dark:tw-text-violet-300',
};

/** Small status pill. */
const Badge = ({ tone = 'neutral', className = '', children }) => (
  <span
    className={`tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-ring-1 tw-ring-inset ${TONES[tone]} ${className}`}
  >
    {children}
  </span>
);

Badge.propTypes = {
  tone: PropTypes.oneOf(Object.keys(TONES)),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Badge;
